import { render } from "./LightboxLink.vue?vue&type=template&id=6d36ac76&scoped=true"
import script from "./LightboxLink.vue?vue&type=script&lang=js"
export * from "./LightboxLink.vue?vue&type=script&lang=js"

import "./LightboxLink.vue?vue&type=style&index=0&id=6d36ac76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d36ac76"]])

export default __exports__